import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

// Subscription Actions 
export const subscribeAction = async (freelancerId) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.SUBSCRIPTIONS.SUBSCRIBE, { freelancer_id: freelancerId });
      return response;
    } catch (error) {
      console.error("Subscription failed:", error);
      throw error;
    }
  };
  
  export const checkSubscription = async (id) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SUBSCRIPTIONS.CHECK(id));
      return response; // Return the response data for the caller to handle
    } catch (error) {
      console.error("Error checking subscription:", error);
      throw error; // Re-throw the error for the caller to handle
    }
  };
  
  export const userSubscriptions = async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SUBSCRIPTIONS.USER_SUBSCRIPTIONS);
      return response; // Return the response data for the caller to handle
    } catch (error) {
      console.error("Error checking subscription:", error);
      throw error; // Re-throw the error for the caller to handle
    }
  };
  
  